import React, { Component, Fragment } from 'react';
import { forwardRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {getListaMtosClienteFiltrado, getListaMtos, deleteProgMtoTabla, postMtoTablaV2, editProgMto,editProgMtoV2} from '../../../redux/actions/dataactions';
import {getUsuariosAsistenciales} from '../../../redux/actions/useractions';


import MyButton from '../../../utils/MyButton';
import './TablaCronogramaMto.css';

import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { FaEye, FaTrashAlt, FaTools, FaSearch, FaPencilAlt } from "react-icons/fa";

import {Link} from 'react-router-dom';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  FormControl, MenuItem, FormHelperText, Select, InputLabel,
  TextField, CircularProgress, Accordion, AccordionSummary, AccordionDetails, Button,
  Typography, Box, Stack, IconButton, Tooltip, Grid,
  Card,
  CardMedia,
  CardActions
} from '@mui/material';

import { FaArrowLeft, FaCheck, FaCheckCircle,  FaFilePdf, FaPlus, FaTrash} from "react-icons/fa";
import CronogramaMtoAuto from './CronogramaMtoAuto';
import CronogramaMtoDuplicarRango from './CronogramaMtoDuplicarRango';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import moment from 'moment';
import TablaCronogramaMtoInd from './TablaCronogramaMtoInd';

import { useDropzone } from 'react-dropzone';

const FileDropzone = ({ onFileDrop }) => {
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({
    accept: {
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    },
    maxFiles: 1,
    onDrop: onFileDrop
  });

  return (
    <div className="dropzone-container mt-4">
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p className="dropzone-text">Arrastra y suelta el archivo aquí, o haz clic para seleccionarlo</p>
        <em className="dropzone-info">(Solo se permite subir un archivo PDF, DOC o DOCX)</em>
      </div>

      <aside className="dropzone-preview">
        {fileRejections.length > 0 && (
          <div className="file-error">
            <h4>Solo se puede cargar un archivo</h4>
          </div>
        )}

        {acceptedFiles.length > 0 && (
          <div className="file-accepted-dropzone">
            <h4 className='text-file-dropzone'>Archivo a cargar:</h4>
            <ul className="file-list-dropzone">
              {acceptedFiles.map(file => (
                <li key={file.path} className="file-item-dropzone">
                  {file.path} - {file.size} bytes
                </li>
              ))}
            </ul>
          </div>
        )}
      </aside>
    </div>
  );
};

export class TablaCronogramaMto extends Component {

  constructor(){
    super();
    this.state={
        chasis:false,
        vaccesorios:false,
        vcontroles:false,
        vgeneral:false,
        limpieza:false,
        lelectronica:false,
        pcuantitativa:false,
        selectrica:false,
        lchasis:false,
        lubricacion:false,
        aptouso:true,
        repuestosreq:false,
        reqmtocorr:false,
        bajaequipo:false,
        pruebas: [{
                      instrumento: '',
                      prueba: '',
                      valor: '',
                      valormed: ''
                    }],
        repuestos: [''],
        actividadesprog:'',
        actividadesreal:'',
        observaciones:'',
        horainicio:'',
        horafinal:'',
        firmarecibe:'',
        cargorecibe:'',
        fecha:'',
        fechafinal:'',
        errors:{},
        aprobado:{},
        open:false,
        opendelete:false,
        openEdit:false,
        progid:'',
        clienteid:'',
        equipoid:'',
        // New fields for reception methods
        metodoRecepcion: 'manual', // default method
        // Digital signature fields
        firmaDigital: null,
        firmaGuardada: false, // Confirmation indicator when signature is saved
        uploadingImage: false, // Control for image uploads
        nombreFirmante: '',
        cargoFirmante: '',
        // User selection fields
        usuarioRecibe: '',
        // Image upload fields
        imagenFirma: null,
        nombreFirmaImagen: '',
        cargoFirmaImagen: '',
        searchQuery: '',
        actividades:'',
        duracion:'',
        hora:'',
        imagenesAdjuntas: [],
        archivoPDF: null,
    };
    
    // Refs for digital signature and image upload
    this.canvasRef = React.createRef();
  };
    
  componentDidMount() {
  const { credentials } = this.props.user;
  const { clienteId } = this.props;

      let responsable = "Todos"; // por defecto para Ingenieros

      if (credentials.tipouser === "Tecnico") {
        responsable = credentials.handle;
      }
      console.log('Responsable '+responsable);

      this.props.getListaMtosClienteFiltrado(
        clienteId,
        "01/01/1950",
        "01/01/2035",
        responsable
      );

      window.addEventListener('resize', this.resizeCanvas);
    }

  componentDidUpdate(prevProps, prevState) {
    // Initialize canvas when metodoRecepcion changes to "firma"
    if (prevState.metodoRecepcion !== this.state.metodoRecepcion) {
      if (this.state.metodoRecepcion === "firma" && this.canvasRef.current) {
        this.initCanvas();
      } else if (this.state.metodoRecepcion === "usuario") {
        // Load healthcare users when this method is selected
        this.props.getUsuariosAsistenciales(this.props.clienteId);
      }
    }
  }

  componentWillUnmount() {
    // Clean up event listeners
    window.removeEventListener('resize', this.resizeCanvas);
  }

 handleSearchChange = (event) => {
  this.setState({ searchQuery: event.target.value });
};

handleResetFiltros = () => {
  const { credentials } = this.props.user;
  const { clienteId } = this.props;

  let responsable = "Todos";
  if (credentials.tipouser === "Tecnico") {
    responsable = credentials.handle;
  }

  this.setState({
    fechaInicio: '',
    fechaFin: '',
    searchQuery: ''
  });

  this.props.getListaMtosClienteFiltrado(
    clienteId,
    "01/01/1950",
    "01/01/2035",
    responsable
  );
};

filterEquipos = () => {
  const { equiposmto } = this.props.data;
  const { searchQuery } = this.state;
  if (!Array.isArray(equiposmto)) return [];

  const lowerQuery = String(searchQuery || '').toLowerCase();

  const filtered = equiposmto.filter((item) => {
    return [
      item.idinventario,
      item.nombre,
      item.marca,
      item.modelo,
      item.serie,
      item.ubicacion,
      item.servicio,
      item.estado,
      item.fecha,
      item.mesnombre,
      item.actividades
    ].some(field =>
      field != null && String(field).toLowerCase().includes(lowerQuery)
    );
  });

  return filtered.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
};

  // Initialize the canvas for signature
  initCanvas = () => {
    if (!this.canvasRef.current) return;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Set up canvas
    this.resizeCanvas();
    
    // Clear the canvas
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // Set up drawing state
    this.isDrawing = false;
    this.lastX = 0;
    this.lastY = 0;
    
    // Set up event listeners for drawing
    canvas.addEventListener('mousedown', this.startDrawing);
    canvas.addEventListener('mousemove', this.draw);
    canvas.addEventListener('mouseup', this.stopDrawing);
    canvas.addEventListener('mouseout', this.stopDrawing);
    
    // Touch events
    canvas.addEventListener('touchstart', this.startDrawingTouch);
    canvas.addEventListener('touchmove', this.drawTouch);
    canvas.addEventListener('touchend', this.stopDrawing);
  }

  // Resize canvas to fit container
  resizeCanvas = () => {
    if (!this.canvasRef.current) return;
    
    const canvas = this.canvasRef.current;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const container = canvas.parentElement;
    
    canvas.width = container.clientWidth * ratio;
    canvas.height = 200 * ratio;
    canvas.style.width = `${container.clientWidth}px`;
    canvas.style.height = "200px";
    
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    
    // Set drawing styles
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'black';
    
    // Fill with white background
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  // Start drawing
  startDrawing = (e) => {
    const canvas = this.canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    this.isDrawing = true;
    this.lastX = e.clientX - rect.left;
    this.lastY = e.clientY - rect.top;
  }

  // Handle touch start
  startDrawingTouch = (e) => {
    e.preventDefault();
    if (e.touches.length !== 1) return;
    
    const touch = e.touches[0];
    const canvas = this.canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    
    this.isDrawing = true;
    this.lastX = touch.clientX - rect.left;
    this.lastY = touch.clientY - rect.top;
  }

  // Draw on the canvas
  draw = (e) => {
    if (!this.isDrawing) return;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    
    const currentX = e.clientX - rect.left;
    const currentY = e.clientY - rect.top;
    
    ctx.beginPath();
    ctx.moveTo(this.lastX, this.lastY);
    ctx.lineTo(currentX, currentY);
    ctx.stroke();
    
    this.lastX = currentX;
    this.lastY = currentY;
  }

  // Handle touch move
  drawTouch = (e) => {
    e.preventDefault();
    if (!this.isDrawing || e.touches.length !== 1) return;
    
    const touch = e.touches[0];
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    
    const currentX = touch.clientX - rect.left;
    const currentY = touch.clientY - rect.top;
    
    ctx.beginPath();
    ctx.moveTo(this.lastX, this.lastY);
    ctx.lineTo(currentX, currentY);
    ctx.stroke();
    
    this.lastX = currentX;
    this.lastY = currentY;
  }

  // Stop drawing
  stopDrawing = () => {
    this.isDrawing = false;
  }

  // Clear digital signature
  clearSignature = () => {
    if (!this.canvasRef.current) return;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Clear canvas
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    this.setState({ firmaDigital: null });
  }

  // Check if canvas is empty
  isCanvasEmpty = () => {
    if (!this.canvasRef.current) return true;
    
    const canvas = this.canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    
    // Check if all pixel data is white (255, 255, 255, 255)
    for (let i = 0; i < pixelData.length; i += 4) {
      // Check RGB values (skip alpha)
      if (pixelData[i] !== 255 || pixelData[i + 1] !== 255 || pixelData[i + 2] !== 255) {
        return false; // Found a non-white pixel
      }
    }
    
    return true; // Canvas is empty (all white)
  }

  // Save digital signature
  saveSignature = () => {
    if (!this.canvasRef.current) return;
    
    if (!this.isCanvasEmpty()) {
      const signatureData = this.canvasRef.current.toDataURL('image/png');
      
      // Save signature and set firmaGuardada to true
      this.setState({ 
        firmaDigital: signatureData,
        firmaGuardada: true, // Visual indicator that the signature was saved
        errors: {
          ...this.state.errors,
          firmaDigital: null
        }
      });
      
      // Show confirmation message that disappears after a few seconds
      setTimeout(() => {
        this.setState({ firmaGuardada: false });
      }, 3000);
    } else {
      // Show error - empty signature
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          firmaDigital: "Es necesario firmar antes de guardar"
        }
      }));
    }
  }

  // Handle image upload
  handleImageButtonClick = () => {
    // Create a temporary file input
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    
    // Set up the event handler before activating the input
    fileInput.addEventListener('change', (event) => {
      const file = event.target.files[0];
      if (file) {
        this.setState({ uploadingImage: true });
        
        const reader = new FileReader();
        
        reader.onload = (e) => {
          this.setState({ 
            imagenFirma: e.target.result,
            uploadingImage: false,
            errors: {
              ...this.state.errors,
              imagenFirma: null
            }
          });
        };
        
        reader.onerror = () => {
          this.setState({ 
            uploadingImage: false,
            errors: {
              ...this.state.errors,
              imagenFirma: "Error al cargar la imagen"
            }
          });
        };
        
        reader.readAsDataURL(file);
      }
    });
    
    // Simulate clicking the input
    fileInput.click();
  }

  // Get user info by ID from props
  getUserInfo = (userId, field) => {
    const { usuariosAsistenciales } = this.props.user;
    
    if (!usuariosAsistenciales) return '';
    
    const user = usuariosAsistenciales.find(u => u.idUsuario === userId);
    
    // If the field is 'cargo' but doesn't exist, provide a default value
    if (field === 'cargo' && (!user || !user[field])) {
      return 'Asistencial';
    }
    
    return user ? user[field] : '';
  }

  handleFiltrar = () => {
      const { credentials } = this.props.user;
      const { clienteId } = this.props;
      const { fechaInicio, fechaFin } = this.state;

      let responsable = "Todos";
      if (credentials.tipouser === "Tecnico") {
        responsable = credentials.handle;
      }

      this.props.getListaMtosClienteFiltrado(
        clienteId,
        moment(fechaInicio).format('DD/MM/YYYY'),
        moment(fechaFin).format('DD/MM/YYYY'),
        responsable
      );
    }

  static getDerivedStateFromProps(props, state) {
    const newState = {};

    if (props.UI.errors) {
      newState.errors = props.UI.errors;
    }

    if (props.UI.aprobado) {
      newState.aprobado = props.UI.aprobado;
    }

    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpen = (rawdataprogid, rawdataequipoid, rawdatafecha, rawdatahora, rawdataactividades) => {
    this.setState({
      open: true,
      progid: rawdataprogid,
      fecha: rawdatafecha,
      horainicio: rawdatahora,
      equipoid: rawdataequipoid,
      actividadesprog: rawdataactividades,
      errors:{},aprobado:{}
    });
  };

  handleClose = () => {
  const { credentials } = this.props.user;
  const { clienteId } = this.props;

  let responsable = "Todos";
  if (credentials.tipouser === "Tecnico") {
    responsable = credentials.handle;
  }

  if (this.state.aprobado.mensaje) {
    this.setState({ open: false, errors: {}, aprobado: {} });
    this.props.getListaMtosClienteFiltrado(
      clienteId,
      "01/01/1950",
      "01/01/2035",
      responsable
    );
  } else {
    this.setState({ open: false, errors: {}, aprobado: {} });
  }
};

  handleOpenDelete = (rawdataprogid, rawdataclienteid, rawdataequipoid) => {
    console.log(rawdataprogid);
    this.setState({
      opendelete: true,
      progid: rawdataprogid,
      clienteid: rawdataclienteid,
      equipoid: rawdataequipoid
    });
  };

  handleCloseDelete = () => {
     const { credentials } = this.props.user;
        const { clienteId } = this.props;

        let responsable = "Todos";
        if (credentials.tipouser === "Tecnico") {
          responsable = credentials.handle;
        }
    if (this.state.aprobado.mensaje) {
      console.log(this.state.aprobado);
      
      this.setState({opendelete: false, errors: {}, aprobado: {}});
      this.props.getListaMtosClienteFiltrado(
          clienteId,
          "01/01/1950",
          "01/01/2035",
          responsable
        );
    }
    else {
      this.setState({opendelete: false, errors: {}, aprobado: {}});
    }
  };

  handleDelete = () => {
    
    this.props.deleteProgMtoTabla(this.state.progid);
   
  }

  handleEditProgMto = () => {
    this.props.editProgMto({nuevoestado: 'Realizado'}, this.state.progid, this.state.equipoid); 
    this.handleClose();
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value});
  };

  // Method selection change handler
  handleMethodChange = (event) => {
    const method = event.target.value;
    this.setState({ metodoRecepcion: method });
    
    // If user selection is chosen, load the list of healthcare users
    if (method === 'usuario') {
      this.props.getUsuariosAsistenciales(this.props.clienteId);
    }
  }

  handleAddPrueba = () => {
  if (this.state.pruebas.length < 6) {
    this.setState(prevState => ({
      pruebas: [...prevState.pruebas, { instrumento: '', prueba: '', valor: '', valormed: '' }]
    }));
      }
    };

    handlePruebaChange = (index, field, value) => {
      const nuevasPruebas = [...this.state.pruebas];
      nuevasPruebas[index][field] = value;
      this.setState({ pruebas: nuevasPruebas });
    };

    handleRemovePrueba = (index) => {
      const nuevasPruebas = [...this.state.pruebas];
      nuevasPruebas.splice(index, 1);
      this.setState({ pruebas: nuevasPruebas });
    };

    handleArchivoDrop = (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        this.setState({ archivoPDF: acceptedFiles[0] });
      }
    };

      handleImagenesSeleccionadas = (event) => {
        const archivos = Array.from(event.target.files);
        const nuevasImagenes = [...this.state.imagenesAdjuntas, ...archivos].slice(0, 3);
        this.setState({ imagenesAdjuntas: nuevasImagenes });
      };

      handleRemoveImagen = (index) => {
        const nuevas = [...this.state.imagenesAdjuntas];
        nuevas.splice(index, 1);
        this.setState({ imagenesAdjuntas: nuevas });
      };

      handleAddRepuesto = () => {
  if (this.state.repuestos.length < 6) {
    this.setState((prevState) => ({
      repuestos: [...prevState.repuestos, '']
    }));
  }
};

handleRemoveRepuesto = (index) => {
  const nuevos = [...this.state.repuestos];
  nuevos.splice(index, 1);
  this.setState({ repuestos: nuevos });
};

handleRepuestoChange = (index, value) => {
  const nuevos = [...this.state.repuestos];
  nuevos[index] = value;
  this.setState({ repuestos: nuevos });
};

  // Modified handlePostMto to include new reception methods and use postMtoTablaV2
  handlePostMto = () => {
  const { credentials } = this.props.user;

  const pruebasProcesadas = this.state.pruebas.map((p, index) => ({
    [`instrumento${index + 1}`]: p.instrumento,
    [`prueba${index + 1}`]: p.prueba,
    [`valor${index + 1}`]: p.valor,
    [`valormed${index + 1}`]: p.valormed,
  }));

  let receptorInfo = {};

  switch (this.state.metodoRecepcion) {
    case 'manual':
      receptorInfo = {
        firmarecibe: this.state.firmarecibe,
        cargorecibe: this.state.cargorecibe,
        metodoRecepcion: 'manual'
      };
      break;

    case 'firma':
      if (this.canvasRef.current && !this.isCanvasEmpty()) {
        const signatureData = this.canvasRef.current.toDataURL('image/png');
        receptorInfo = {
          nombreFirmante: this.state.nombreFirmante,
          cargoFirmante: this.state.cargoFirmante,
          firmaDigital: signatureData,
          metodoRecepcion: 'firma'
        };
      } else {
        this.setState(prevState => ({
          errors: {
            ...prevState.errors,
            firmaDigital: "Es necesario firmar antes de guardar"
          }
        }));
        return;
      }
      break;

    case 'usuario':
      if (this.state.usuarioRecibe) {
        receptorInfo = {
          usuarioRecibe: this.state.usuarioRecibe,
          metodoRecepcion: 'usuario'
        };
      } else {
        this.setState(prevState => ({
          errors: {
            ...prevState.errors,
            usuarioRecibe: "Debe seleccionar un usuario"
          }
        }));
        return;
      }
      break;

    case 'imagen':
      if (this.state.imagenFirma) {
        receptorInfo = {
          nombreFirmaImagen: this.state.nombreFirmaImagen,
          cargoFirmaImagen: this.state.cargoFirmaImagen,
          imagenFirma: this.state.imagenFirma,
          metodoRecepcion: 'imagen'
        };
      } else {
        this.setState(prevState => ({
          errors: {
            ...prevState.errors,
            imagenFirma: "Se requiere una imagen de firma"
          }
        }));
        return;
      }
      break;

    default:
      receptorInfo = {
        firmarecibe: this.state.firmarecibe,
        cargorecibe: this.state.cargorecibe,
        metodoRecepcion: 'manual'
      };
  }

  const newMtoPreventivo = {
    chasis: this.state.chasis,
    vaccesorios: this.state.vaccesorios,
    vcontroles: this.state.vcontroles,
    vgeneral: this.state.vgeneral,
    limpieza: this.state.limpieza,
    lelectronica: this.state.lelectronica,
    pcuantitativa: this.state.pcuantitativa,
    selectrica: this.state.selectrica,
    lchasis: this.state.lchasis,
    lubricacion: this.state.lubricacion,
    actividadesprog: this.state.actividadesprog,
    actividadesreal: this.state.actividadesreal,
    observaciones: this.state.observaciones,
    horainicio: this.state.horainicio,
    horafinal: this.state.horafinal,
    fecha: this.state.fecha,
    fechafinal: this.state.fechafinal,
    ...this.state.repuestos.reduce((acc, valor, index) => {
        acc[`repuesto${index + 1}`] = valor;
        return acc;
      }, {}),
    aptouso: this.state.aptouso,
    repuestosreq: this.state.repuestosreq,
    reqmtocorr: this.state.reqmtocorr,
    bajaequipo: this.state.bajaequipo,
    imagenesAdjuntas: this.state.imagenesAdjuntas,
    archivoPDF: this.state.archivoPDF,
    ...Object.assign({}, ...pruebasProcesadas),
    ...receptorInfo
  };

  // ✅ Aquí se realiza finalmente la acción
  const { equipoid, progid } = this.state;
  const clienteid = this.props.clienteId;
  const handle = credentials.tipouser === "Tecnico" ? credentials.handleuser : credentials.handle;
  console.log(newMtoPreventivo);
 this.props.postMtoTablaV2(newMtoPreventivo, equipoid, clienteid, progid, handle);
}


  handleOpenEdit = (rawdataprogid, rawdataclienteid, rawdataequipoid,rawdatafecha,rawdataactividades,rawdataduracion,rawdatahora) => {
    console.log(rawdataprogid);
    this.setState({
      openEdit: true,
      progid: rawdataprogid,
      fecha:rawdatafecha,
      hora:rawdatahora,
      actividades:rawdataactividades,
      clienteid: rawdataclienteid,
      duracion:rawdataduracion,
      equipoid: rawdataequipoid
    });
  };

  handleCloseEdit = () => {
    const { credentials } = this.props.user;
      const { clienteId } = this.props;

      let responsable = "Todos";
      if (credentials.tipouser === "Tecnico") {
        responsable = credentials.handle;
      }

    if (this.state.aprobado.mensaje) {
      console.log(this.state.aprobado);
      
      this.setState({openEdit: false, errors: {}, aprobado: {},fecha:'',hora:'',duracion:'',actividades:''});
      this.props.getListaMtosClienteFiltrado(
          clienteId,
          "01/01/1950",
          "01/01/2035",
          responsable
        );
    }
    else {
      this.setState({openEdit: false, errors: {}, aprobado: {},fecha:'',hora:'',duracion:'',actividades:''});
    }
  };

  handleEdit=(event)=>{

      event.preventDefault();

        let fechamto=new Date(this.state.fecha);
        let day;
        let mes;
        let newfecha;
        let year;
        let mesnombre;

        if(fechamto.getDate()>=30){
          day=1;
          
          mes=fechamto.getMonth()+1;
          if(mes>11){
            mes=0;
            year=fechamto.getFullYear()+1;
          }else{
            year=fechamto.getFullYear();
          }
          newfecha=fechamto.setDate(day);
          newfecha=fechamto.setMonth(mes);
          newfecha=new Date(newfecha);
          mes=mes+1;
          mesnombre=newfecha.toLocaleString('es-Es', {
            month: 'long',
          });
        }else{
          day=fechamto.getDate()+1;
          mes=fechamto.getMonth()+1;
          year=fechamto.getFullYear();
          mesnombre=fechamto.toLocaleString('es-Es', {
            month: 'long',
          });
        }
        
        
       

        const newProgramacion={
          fecha:this.state.fecha,
          hora:this.state.hora,
          dia:day,
          mes:mes,
          mesnombre:mesnombre,
          year:year,
          duracion:this.state.duracion,
          actividades:this.state.actividades,
             
      };

      console.log(newProgramacion);
      console.log('ProgID' + this.state.progid);
   

      this.props.editProgMtoV2(newProgramacion,this.state.progid); 

  }

    render() {
        const {equiposmto,loadingmto}= this.props.data;
        const {errors}=this.state;
        const{aprobado}=this.state;
        const { UI:{loading}}=this.props; 
        const filteredRows = this.filterEquipos().map((row, index) => ({ id: index, ...row }));
        const columns = [
          {
            field: 'acciones',
            headerName: 'Acciones',
            width: 180,
            sortable: false,
            renderCell: (params) => (
              <Stack direction="row" spacing={1}>
                <Tooltip title="Ver perfil">
                  <IconButton
                    component={Link}
                    to={`/dashboard/perfilcliente/equipo/${this.props.clienteId}/${params.row.equipoid}`}
                    size="small"
                  >
                    <FaEye />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Mantenimiento">
                  <span>
                    <IconButton
                     onClick={() => this.handleOpen(params.row.progMtoId, params.row.equipoid, params.row.fecha, params.row.hora, params.row.actividades)}
                    disabled={params.row.estado === 'Realizado'}
                      size="small"
                    >
                      <FaTools />
                    </IconButton>
                  </span>
                </Tooltip>
                
                <Tooltip title="Eliminar">
                  <IconButton
                    onClick={() => this.handleOpenDelete(params.row.progMtoId, params.row.clienteid, params.row.equipoid)}
                    size="small"
                  >
                    <FaTrashAlt />
                  </IconButton>
                </Tooltip>

                  <Tooltip title="Editar">
                  <span>
                    <IconButton
                     onClick={() => this.handleOpenEdit(params.row.progMtoId, params.row.clienteid, params.row.equipoid,params.row.fecha,params.row.actividades,params.row.duracion,params.row.hora)}
                    disabled={params.row.estado === 'Realizado'}
                      size="small"
                    >
                     <FaPencilAlt />
                    </IconButton>
                  </span>
                </Tooltip>

                <Tooltip title="Ver Reporte">
                  <IconButton
                    component={Link}
                    to={`/dashboard/perfilcliente/${this.props.clienteId}/cronomtoperfil/reportepdfmto/${params.row.equipoid}/${params.row.progMtoId}/2`}
                    size="small"
                    disabled={params.row.estado === 'Sin realizar'}
                  >
                    <FaFilePdf />
                  </IconButton>
                </Tooltip>
                
              </Stack>
            )
          },
          { field: 'idinventario', headerName: 'ID', width: 130 },
          {field:'mtoprevid',headerName: 'Reporte ID', width: 130},
          { field: 'nombre', headerName: 'Nombre', width: 130 },
          { field: 'marca', headerName: 'Marca', width: 100 },
          { field: 'modelo', headerName: 'Modelo', width: 100 },
          { field: 'serie', headerName: 'Serie', width: 100 },
          { field: 'ubicacion', headerName: 'Ubicación', width: 120 },
          { field: 'servicio', headerName: 'Servicio', width: 120 },
          { field: 'estado', headerName: 'Estado', width: 100 },
          { field: 'fecha', headerName: 'Fecha', width: 120 },
          { field: 'mesnombre', headerName: 'Mes', width: 100 },
           { field: 'responsable', headerName: 'Responsable', width: 100 },
          { field: 'actividades', headerName: 'Actividades', width: 200 }
        ];
     
       
        
        let mapeoequipos=!loadingmto?(
        <div>
          <div className='inventory-links-grid'>

           {this.props.user.credentials.tipouser !== "Tecnico" && (
              <Fragment>
                <CronogramaMtoAuto clienteId={this.props.clienteId} />
                <CronogramaMtoDuplicarRango clienteId={this.props.clienteId} />
              </Fragment>
            )}
            <TablaCronogramaMtoInd clienteId={this.props.clienteId}></TablaCronogramaMtoInd>
          <Fragment>
                        <Link className='div-card-link' to={`/dashboard/perfilcliente/cronograma/${this.props.clienteId}`} state={equiposmto} >
                          <div className="dashing-cardcontent">
                                              <div className="dashing-cardtext">
                                                  <p className="dashing-text-card">
                                                 Ver en PDF
                                                  </p>
                              
                                              </div>
                                              <div className="dashing-cardicon-green">
                                                  <FaFilePdf color="#FFFFFF" className="dashing-icon"/>
                                              </div>
                                          </div>


                        </Link>
                        </Fragment>
          </div>

          <>
          <Box sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
              <TextField
                 sx={{mb: 2 }}
                fullWidth
                size="small"
                label="Buscar programación"
                variant="outlined"
                value={this.state.searchQuery}
                onChange={this.handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <Box component="span" sx={{ mr: 1 }}>
                     <FaSearch color="#d7d7d7" />
                    </Box>
                  )
                }}
              />
            </Grid>
  <Grid container spacing={2} alignItems="center">
    <Grid item xs={12} sm={4} md={3}>
      <TextField
        fullWidth
        size="small"
        required
        type="date"
        name="fechaInicio"
        id="fechaInicio"
        label="Desde"
        value={this.state.fechaInicio}
        onChange={this.handleChange}
        helperText={errors.fechaInicio}
        error={Boolean(errors.fechaInicio)}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Grid>

    <Grid item xs={12} sm={4} md={3}>
      <TextField
        fullWidth
        size="small"
        required
        type="date"
        name="fechaFin"
        id="fechaFin"
        label="Hasta"
        value={this.state.fechaFin}
        onChange={this.handleChange}
        helperText={errors.fechaFin}
        error={Boolean(errors.fechaFin)}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Grid>

    <Grid item xs={12} sm={4} md={3}>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={this.handleFiltrar}
        size="medium"
        sx={{ height: '100%' }}
      >
        Filtrar
      </Button>
    </Grid>

    <Grid item xs={12} sm={4} md={3}>
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          onClick={this.handleResetFiltros}
          size="medium"
          sx={{ height: '100%' }}
        >
          Restablecer
        </Button>
      </Grid>
  </Grid>
</Box>
          </>


        <Box sx={{ height: 600, width: '100%', mt: 3 }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={100}
              rowsPerPageOptions={[10, 20, 50]}
              localeText={esES.components.MuiDataGrid.defaultProps.localeText}
              disableRowSelectionOnClick
              loading={loadingmto}
              sx={{
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#1976d2',  // primary color
                  color: '#ffffff',
                  fontWeight: 'bold'
                },
                '& .MuiDataGrid-cell': {
                  fontSize: '13px'
                }
              }}
            />
          </Box>
        
        </div>
        ):(
        <div className="div_cargando">
           <CircularProgress size={50}color="primary" className="login-progress" />
        </div>
        )


        return (
            <div>
                {mapeoequipos}

                <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          {this.state.aprobado.mensaje ? (
            <div className='div-aprobado'>
              <div className='div-icono-aprobado'>
                <FaCheck color="#ffffff" className='icono-aprobado'/>
              </div>
              <h2 className='text-aprobado'>Reporte Cargado Exitosamente</h2>
            </div>
          ) : (
            <div>
              <DialogTitle>
                 <Typography sx={{ 
                                  fontSize: '20px', 
                                  fontWeight: 600, 
                                  color: '#0468BF', 
                                  textAlign: 'center' 
                                  }}>
                                  Realizar Reporte de Mantenimiento Preventivo
                  </Typography>
              </DialogTitle>
              <DialogContent>
                <form>
                  <Accordion>
                     <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography sx={{
                    color: '#0468BF',
                    fontSize: '18px',
                    fontWeight: 400,
                    ml: 1,
                  }}>
                    Actividades Realizadas
                  </Typography>
                </AccordionSummary>
                    <AccordionDetails>
                                    <Grid container spacing={2}>
                                          {/* Primera fila */}
                                          <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>Inspección Chásis</InputLabel>
                                              <Select
                                                required
                                                name="chasis"
                                                value={this.state.chasis}
                                                onChange={this.handleChange}
                                                label="Inspección Chásis"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.chasis}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                                    
                                          <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>Verificar Accesorios</InputLabel>
                                              <Select
                                                required
                                                name="vaccesorios"
                                                value={this.state.vaccesorios}
                                                onChange={this.handleChange}
                                                label="Verificar Accesorios"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.vaccesorios}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                                    
                                          {/* Segunda fila */}
                                          <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>Verificar Controles</InputLabel>
                                              <Select
                                                required
                                                name="vcontroles"
                                                value={this.state.vcontroles}
                                                onChange={this.handleChange}
                                                label="Verificar Controles"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.vcontroles}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                                    
                                          <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>Prueba Cuantitativa</InputLabel>
                                              <Select
                                                required
                                                name="pcuantitativa"
                                                value={this.state.pcuantitativa}
                                                onChange={this.handleChange}
                                                label="Prueba Cuantitativa"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.pcuantitativa}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                                    
                                          {/* Tercera fila */}
                                          <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>Pruebas Electricas</InputLabel>
                                              <Select
                                                required
                                                name="selectrica"
                                                value={this.state.selectrica}
                                                onChange={this.handleChange}
                                                label="Pruebas Electricas"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.selectrica}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                                    
                                          <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>Limpieza</InputLabel>
                                              <Select
                                                required
                                                name="limpieza"
                                                value={this.state.limpieza}
                                                onChange={this.handleChange}
                                                label="Limpieza"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.limpieza}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                                    
                                          {/* Cuarta fila */}
                                          <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>Lubricación de Partes</InputLabel>
                                              <Select
                                                required
                                                name="lubricacion"
                                                value={this.state.lubricacion}
                                                onChange={this.handleChange}
                                                label="Lubricación de Partes"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.lubricacion}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                                    
                                          <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>Limpieza Electrónica</InputLabel>
                                              <Select
                                                required
                                                name="lelectronica"
                                                value={this.state.lelectronica}
                                                onChange={this.handleChange}
                                                label="Limpieza Electrónica"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.lelectronica}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                                    
                                          {/* Quinta fila */}
                                          <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>Limpieza de Chásis</InputLabel>
                                              <Select
                                                required
                                                name="lchasis"
                                                value={this.state.lchasis}
                                                onChange={this.handleChange}
                                                label="Limpieza de Chásis"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.lchasis}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                                    
                                          <Grid item xs={12} md={6}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>Verificación General</InputLabel>
                                              <Select
                                                required
                                                name="vgeneral"
                                                value={this.state.vgeneral}
                                                onChange={this.handleChange}
                                                label="Verificación General"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.vgeneral}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                                        </Grid>
                                      </AccordionDetails>
                  </Accordion>

                  <Accordion>
                   <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        ml: 1,
                      }}>
                        Mediciones Realizadas
                      </Typography>
                    </AccordionSummary>
                   <AccordionDetails>
                              {this.state.pruebas.map((prueba, index) => (
                    <Fragment key={index}>
                      <Grid item xs={12} md={3} mt={1}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          label={`Instrumento ${index + 1}`}
                          value={prueba.instrumento}
                          onChange={(e) => this.handlePruebaChange(index, 'instrumento', e.target.value)}
                          error={Boolean(errors[`instrumento${index + 1}`])}
                          helperText={errors[`instrumento${index + 1}`]}
                        />
                      </Grid>

                      <Grid item xs={12} md={3} mt={1}>
                        <FormControl fullWidth variant="outlined" size="small" error={Boolean(errors[`prueba${index + 1}`])}>
                          <InputLabel>Variable</InputLabel>
                          <Select
                            value={prueba.prueba}
                            onChange={(e) => this.handlePruebaChange(index, 'prueba', e.target.value)}
                            label="Variable"
                          >
                            <MenuItem value=""><em>Seleccionar</em></MenuItem>
                            <MenuItem value="velocidad">Velocidad</MenuItem>
                            <MenuItem value="rpm">RPM</MenuItem>
                            <MenuItem value="energia">Energía</MenuItem>
                            <MenuItem value="flujo">Flujo</MenuItem>
                            <MenuItem value="nibp">NIBP</MenuItem>
                            <MenuItem value="peep">PEEP</MenuItem>
                            <MenuItem value="presion">Presión</MenuItem>
                            <MenuItem value="relacionie">Relación I:E</MenuItem>
                            <MenuItem value="ecg">ECG</MenuItem>
                            <MenuItem value="temperatura">Temperatura</MenuItem>
                            <MenuItem value="peso">Peso</MenuItem>
                            <MenuItem value="fio2">FIO2</MenuItem>
                            <MenuItem value="volumen">Volumen</MenuItem>
                            <MenuItem value="spo2">Spo2</MenuItem>
                            <MenuItem value="frecuencia">Frecuencia</MenuItem>
                            <MenuItem value="dB">dB</MenuItem>
                            <MenuItem value="etco2">EtCO2</MenuItem> 
                            <MenuItem value="co2inspirado">CO2 Inspirado</MenuItem>
                            <MenuItem value="frecuenciarespiratoria">Frecuencia Respiratoria</MenuItem>
                            <MenuItem value="frecuenciacardiaca">Frecuencia Cardíaca</MenuItem>
                            <MenuItem value="IBP">Presión Invasiva</MenuItem>
                            <MenuItem value="presionpico">Presión Pico</MenuItem>
                            <MenuItem value="corriente">Corriente (A)</MenuItem>
                            <MenuItem value="voltaje">Voltaje (V)</MenuItem>
                            <MenuItem value="potencia">Potencia (W)</MenuItem>
                            <MenuItem value="resistencia">Resistencia (Ohm)</MenuItem>
                            <MenuItem value="frecuenciaelectrica">Frecuencia Eléctrica (Hz)</MenuItem>
                            <MenuItem value="ph">pH</MenuItem>
                            <MenuItem value="pco2">PCO2</MenuItem>
                            <MenuItem value="po2">PO2</MenuItem>
                            <MenuItem value="concentraciongas">Concentración de Gas</MenuItem>
                            <MenuItem value="tiemporespuesta">Tiempo de Respuesta</MenuItem>
                            <MenuItem value="linealidad">Linealidad</MenuItem>
                            <MenuItem value="exactitud">Exactitud</MenuItem>

                            <MenuItem value="precision">Precisión</MenuItem>
                          </Select>
                           <FormHelperText>{errors[`prueba${index + 1}`]}</FormHelperText>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={2} mt={1}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="Valor Referencia"
                          value={prueba.valor}
                          onChange={(e) => this.handlePruebaChange(index, 'valor', e.target.value)}
                          error={Boolean(errors[`valor${index + 1}`])}
                          helperText={errors[`valor${index + 1}`]}
                        />
                      </Grid>

                      <Grid item xs={12} md={2} mt={1}>
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          label="Valor Medido"
                          value={prueba.valormed}
                          onChange={(e) => this.handlePruebaChange(index, 'valormed', e.target.value)}
                          error={Boolean(errors[`valormed${index + 1}`])}
                          helperText={errors[`valormed${index + 1}`]}
                        />
                      </Grid>

                      <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center">
                        <Tooltip title="Eliminar prueba">
                          <IconButton color="error" onClick={() => this.handleRemovePrueba(index)}>
                            <FaTrash />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Fragment>
                  ))}

                  {this.state.pruebas.length < 6 && (
                      <Grid item xs={12}>
                        <Button
                          variant="outlined"
                          startIcon={<FaPlus />}
                          onClick={this.handleAddPrueba}
                        >
                          Agregar Prueba
                        </Button>
                      </Grid>
                    )}
                                   </AccordionDetails>
                  </Accordion>

                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3a-content"
                      id="panel3a-header"
                    >
                      <Typography sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        ml: 1,
                      }}>
                        Descripcion de Actividades
                      </Typography>
                    </AccordionSummary>
                   <AccordionDetails>
                     <Grid container spacing={2}>
                                         <Grid item xs={12} mt={1}>
                                           <TextField
                                             fullWidth
                                             multiline
                                             rows={4}
                                             variant="outlined"
                                             size="small"
                                             label="Actividades Programadas"
                                             name="actividadesprog"
                                             value={this.state.actividadesprog}
                                             onChange={this.handleChange}
                                             error={Boolean(errors.actividadesprog)}
                                             helperText={errors.actividadesprog}
                                           />
                                         </Grid>
                                       </Grid>

                    <Grid container spacing={2}>
                                         <Grid item xs={12} mt={1}>
                                           <TextField
                                             fullWidth
                                             multiline
                                             rows={4}
                                             variant="outlined"
                                             size="small"
                                             label="Actividades Realizadas"
                                             name="actividadesreal"
                                             value={this.state.actividadesreal}
                                             onChange={this.handleChange}
                                             error={Boolean(errors.actividadesreal)}
                                             helperText={errors.actividadesreal}
                                           />
                                         </Grid>
                                       </Grid>
                                   <Grid container spacing={2}>
                                         <Grid item xs={12} mt={1}>
                                           <TextField
                                             fullWidth
                                             multiline
                                             rows={4}
                                             variant="outlined"
                                             size="small"
                                             label="Observaciones"
                                             name="observaciones"
                                             value={this.state.observaciones}
                                             onChange={this.handleChange}
                                             error={Boolean(errors.observaciones)}
                                             helperText={errors.observaciones}
                                           />
                                         </Grid>
                                       </Grid>
                                   </AccordionDetails>
                  </Accordion>
                      <Accordion>
                         <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3a-content"
                      id="panel3a-header"
                    >
                      <Typography sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        ml: 1,
                      }}>
                        Archivos Adjuntos
                      </Typography>
                    </AccordionSummary>
                        <AccordionDetails>
                          {
                            //Dropzone para cargar archivos debe incluir el nombre del archivo que se quiere subir
                          }
                            <Grid container spacing={2}>

                        {/* Archivo PDF/DOC/DOCX */}
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" sx={{
                        color: '#0468BF',
                        fontSize: '16px',
                        fontWeight: 400,
                        ml: 1,
                      }}>Adjuntar archivo PDF, DOC o DOCX</Typography>
                          <FileDropzone onFileDrop={this.handleArchivoDrop} />
                        </Grid>
                        </Grid>

                           {
                            //Visualización previa de imagenes
                          }

                          <Grid item xs={12}>
                          <Typography variant="subtitle2" sx={{
                        color: '#0468BF',
                        fontSize: '16px',
                        fontWeight: 400,
                        ml: 1,
                        mt:2
                      }}>Adjuntar imágenes (JPG, PNG)</Typography>

                          <Button
                            variant="contained"
                            component="label"
                            disabled={this.state.imagenesAdjuntas.length >= 3}
                          >
                            Seleccionar imágenes
                            <input
                              type="file"
                              accept="image/*"
                              multiple
                              hidden
                              onChange={this.handleImagenesSeleccionadas}
                            />
                          </Button>
                        </Grid>

                       <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{
                        color: '#0468BF',
                        fontSize: '16px',
                        fontWeight: 400,
                        ml: 1,
                        mt:2
                      }} gutterBottom>Imágenes seleccionadas</Typography>
                        <Grid container spacing={2}>
                          {this.state.imagenesAdjuntas.map((img, idx) => (
                            <Grid item xs={12} sm={4} md={4} key={idx}>
                              <Card sx={{ width: '100%', aspectRatio: '1 / 1', position: 'relative' }}>
                                <CardMedia
                                  component="img"
                                  image={URL.createObjectURL(img)}
                                  alt={`Imagen ${idx + 1}`}
                                  sx={{
                                    objectFit: 'cover',
                                    width: '100%',
                                    height: '100%',
                                    aspectRatio: '1 / 1'
                                  }}
                                />
                                <CardActions sx={{ position: 'absolute', top: 0, right: 0 }}>
                                  <Tooltip title="Eliminar imagen">
                                    <IconButton color="error" onClick={() => this.handleRemoveImagen(idx)}>
                                      <FaTrash />
                                    </IconButton>
                                  </Tooltip>
                                </CardActions>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>

                        </AccordionDetails>
                      </Accordion>
                  
                  <Accordion>
                     <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3a-content"
                      id="panel3a-header"
                    >
                      <Typography sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        ml: 1,
                      }}>
                        Repuestos Recomendados 
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
  <Grid container spacing={2}>
    {this.state.repuestos.map((repuesto, index) => (
      <Grid item xs={12} sm={6} key={index}>
        <TextField
          fullWidth
          label={`Repuesto ${index + 1}`}
          value={repuesto}
          onChange={(e) => this.handleRepuestoChange(index, e.target.value)}
          variant="outlined"
          size="small"
          InputProps={{
            endAdornment: this.state.repuestos.length > 1 && (
              <Tooltip title="Eliminar">
                <IconButton onClick={() => this.handleRemoveRepuesto(index)} edge="end" size="small" color="error">
                  <FaTrash />
                </IconButton>
              </Tooltip>
            )
          }}
        />
      </Grid>
    ))}

    {this.state.repuestos.length < 6 && (
      <Grid item xs={12}>
        <Button
          variant="outlined"
          startIcon={<FaPlus />}
          onClick={this.handleAddRepuesto}
        >
          Agregar Repuesto
        </Button>
      </Grid>
    )}
  </Grid>
</AccordionDetails>
                  </Accordion>

                   <Accordion>
                     <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3a-content"
                      id="panel3a-header"
                    >
                      <Typography sx={{
                        color: '#0468BF',
                        fontSize: '18px',
                        fontWeight: 400,
                        ml: 1,
                      }}>
                        Estado del Equipo
                      </Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                        <Grid item xs={12} md={6} mt={2}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>¿Equipo Apto para su Uso?</InputLabel>
                                              <Select
                                                required
                                                name="aptouso"
                                                value={this.state.aptouso}
                                                onChange={this.handleChange}
                                                label="¿Equipo Apto para su Uso?"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.aptouso}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                          <Grid item xs={12} md={6} mt={2}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>¿Requiere repuestos adicionales?</InputLabel>
                                              <Select
                                                required
                                                name="repuestosreq"
                                                value={this.state.repuestosreq}
                                                onChange={this.handleChange}
                                                label="¿Requiere repuestos adicionales?"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.repuestosreq}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                          <Grid item xs={12} md={6} mt={2}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>¿Requiere mantenimiento correctivo?</InputLabel>
                                              <Select
                                                required
                                                name="reqmtocorr"
                                                value={this.state.reqmtocorr}
                                                onChange={this.handleChange}
                                                label="¿Requiere mantenimiento correctivo?"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.reqmtocorr}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                       <Grid item xs={12} md={6} mt={2}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <InputLabel>¿Requiere dar de baja el Equipo?</InputLabel>
                                              <Select
                                                required
                                                name="bajaequipo"
                                                value={this.state.bajaequipo}
                                                onChange={this.handleChange}
                                                label="¿Requiere mantenimiento correctivo?"
                                              >
                                                <MenuItem value=""><em>Seleccionar</em></MenuItem>
                                                <MenuItem value={true}>Sí</MenuItem>
                                                <MenuItem value={false}>N/A</MenuItem>
                                              </Select>
                                              <FormHelperText>{errors.bajaequipo}</FormHelperText>
                                            </FormControl>
                                          </Grid>
                    </AccordionDetails>

                    </Accordion>

                  <Accordion>
                    <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                >
                  <Typography sx={{
                    color: '#0468BF',
                    fontSize: '18px',
                    fontWeight: 400,
                    ml: 1,
                  }}>
                    Fecha y Hora
                  </Typography>
                </AccordionSummary>
                   <AccordionDetails>
          <Grid container spacing={2}>
    {/* Fila: Fechas */}
    <Grid item xs={12} sm={6}>
      <TextField
        required
        fullWidth
        type="date"
        name="fecha"
        id="fecha"
        label="Fecha de Realización"
        value={this.state.fecha}
        onChange={this.handleChange}
        helperText={errors.fecha}
        error={Boolean(errors.fecha)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField
        required
        fullWidth
        type="date"
        name="fechafinal"
        id="fechafinal"
        label="Fecha Final"
        value={this.state.fechafinal}
        onChange={this.handleChange}
        helperText={errors.fechafinal}
        error={Boolean(errors.fechafinal)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>

    {/* Fila: Horas */}
    <Grid item xs={12} sm={6}>
      <TextField
        required
        fullWidth
        type="time"
        name="horainicio"
        id="horainicio"
        label="Hora de Inicio"
        value={this.state.horainicio}
        onChange={this.handleChange}
        helperText={errors.horainicio}
        error={Boolean(errors.horainicio)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField
        required
        fullWidth
        type="time"
        name="horafinal"
        id="horafinal"
        label="Hora Final"
        value={this.state.horafinal}
        onChange={this.handleChange}
        helperText={errors.horafinal}
        error={Boolean(errors.horafinal)}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>
  </Grid>
                                   </AccordionDetails>
                  </Accordion>

                  <Accordion>
                     <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel5a-content"
                  id="panel5a-header"
                >
                  <Typography sx={{
                    color: '#0468BF',
                    fontSize: '18px',
                    fontWeight: 400,
                    ml: 1,
                  }}>
                    Personal que recibe la actividad
                  </Typography>
                </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <FormControl fullWidth size="small">
                                <InputLabel>Método de recepción</InputLabel>
                                <Select
                                  name="metodoRecepcion"
                                  value={this.state.metodoRecepcion || 'manual'}
                                  label="Método de recepción"
                                  onChange={(e) => {
                                    this.handleChange(e);
                                    this.handleMethodChange(e);
                                  }}
                                  error={Boolean(errors.metodoRecepcion)}
                                >
                                  <MenuItem value="manual">Ingreso manual</MenuItem>
                                  <MenuItem value="firma">Firma digital</MenuItem>
                                  <MenuItem value="usuario">Seleccionar usuario</MenuItem>
                                  <MenuItem value="imagen">Cargar imagen</MenuItem>
                                </Select>
                                <FormHelperText>{errors.metodoRecepcion}</FormHelperText>
                              </FormControl>
                            </Grid>
                      
                            {/* ==== Personaliza según el método seleccionado ==== */}
                            {this.state.metodoRecepcion === "manual" && (
                              <>
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    size="small"
                                    label="Nombre de quien recibe la actividad"
                                    name="firmarecibe"
                                    value={this.state.firmarecibe}
                                    onChange={this.handleChange}
                                    error={Boolean(errors.firmarecibe)}
                                    helperText={errors.firmarecibe}
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    size="small"
                                    label="Cargo de quien recibe la actividad"
                                    name="cargorecibe"
                                    value={this.state.cargorecibe}
                                    onChange={this.handleChange}
                                    error={Boolean(errors.cargorecibe)}
                                    helperText={errors.cargorecibe}
                                  />
                                </Grid>
                              </>
                            )}
                      
                            {this.state.metodoRecepcion === "firma" && (
                              <>
                                <Grid item xs={12}>
                                  <div className="firma-canvas-container">
                                    <canvas
                                      ref={this.canvasRef}
                                      id="firma-digital-canvas"
                                      className="firma-canvas"
                                      width="500"
                                      height="200"
                                    />
                                  </div>
                                  <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                                    <Button variant="outlined" onClick={this.clearSignature}>
                                      Limpiar firma
                                    </Button>
                                    <Button variant="contained" onClick={this.saveSignature}>
                                      Guardar firma
                                    </Button>
                                  </Stack>
                                </Grid>
                      
                                {this.state.firmaGuardada && (
                                  <Grid item xs={12}>
                                    <Typography color="success.main" align="center">
                                      Firma guardada correctamente
                                    </Typography>
                                  </Grid>
                                )}
                      
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    size="small"
                                    label="Nombre del firmante"
                                    name="nombreFirmante"
                                    value={this.state.nombreFirmante}
                                    onChange={this.handleChange}
                                    error={Boolean(errors.nombreFirmante)}
                                    helperText={errors.nombreFirmante}
                                  />
                                </Grid>
                      
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    size="small"
                                    label="Cargo del firmante"
                                    name="cargoFirmante"
                                    value={this.state.cargoFirmante}
                                    onChange={this.handleChange}
                                    error={Boolean(errors.cargoFirmante)}
                                    helperText={errors.cargoFirmante}
                                  />
                                </Grid>
                              </>
                            )}
                      
                            {this.state.metodoRecepcion === "usuario" && (
                              <>
                                <Grid item xs={12}>
                                  <FormControl fullWidth size="small">
                                    <InputLabel>Usuario que recibe</InputLabel>
                                    <Select
                                      name="usuarioRecibe"
                                      value={this.state.usuarioRecibe || ''}
                                      onChange={this.handleChange}
                                      label="Usuario que recibe"
                                      error={Boolean(errors.usuarioRecibe)}
                                    >
                                      <MenuItem value=""><em>Seleccione un usuario</em></MenuItem>
                                      {this.props.user.usuariosAsistenciales?.map(user => (
                                        <MenuItem key={user.idUsuario} value={user.idUsuario}>
                                          {user.nombre} {user.cargo ? `- ${user.cargo}` : ''}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    <FormHelperText>{errors.usuarioRecibe}</FormHelperText>
                                  </FormControl>
                                </Grid>
                      
                                {this.state.usuarioRecibe && (
                                  <Grid item xs={12}>
                                    <Typography variant="body2" sx={{ mt: 2 }}>
                                      <strong>Nombre:</strong> {this.getUserInfo(this.state.usuarioRecibe, 'nombre')}
                                    </Typography>
                                    <Typography variant="body2">
                                      <strong>Cargo:</strong> {this.getUserInfo(this.state.usuarioRecibe, 'cargo')}
                                    </Typography>
                                  </Grid>
                                )}
                              </>
                            )}
                      
                            {this.state.metodoRecepcion === "imagen" && (
                              <>
                                <Grid item xs={12}>
                                  <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={this.handleImageButtonClick}
                                    disabled={this.state.uploadingImage}
                                  >
                                    {this.state.uploadingImage ? 'Procesando...' : 'Cargar imagen de firma'}
                                  </Button>
                                </Grid>
                      
                                {this.state.imagenFirma && (
                                  <Grid item xs={12}>
                                    <Box
                                      component="img"
                                      src={this.state.imagenFirma}
                                      alt="Vista previa de firma"
                                      sx={{ maxWidth: '100%', maxHeight: 200, mt: 2 }}
                                    />
                                  </Grid>
                                )}
                      
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    size="small"
                                    label="Nombre del firmante"
                                    name="nombreFirmaImagen"
                                    value={this.state.nombreFirmaImagen}
                                    onChange={this.handleChange}
                                    error={Boolean(errors.nombreFirmaImagen)}
                                    helperText={errors.nombreFirmaImagen}
                                  />
                                </Grid>
                      
                                <Grid item xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    variant="outlined"
                                    size="small"
                                    label="Cargo del firmante"
                                    name="cargoFirmaImagen"
                                    value={this.state.cargoFirmaImagen}
                                    onChange={this.handleChange}
                                    error={Boolean(errors.cargoFirmaImagen)}
                                    helperText={errors.cargoFirmaImagen}
                                  />
                                </Grid>
                              </>
                            )}
                          </Grid>
                     </AccordionDetails>
                  </Accordion>
                </form>
              </DialogContent>
            </div>
          )}

          <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
              <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
            </MyButton>
            {loading ? (
              <CircularProgress size={30} color="primary" className="login-progress" />
            ) : (
              this.state.aprobado.mensaje ? (
                <MyButton tip="Continuar" onClick={this.handleClose}>
                  <FaCheckCircle color="#20B90C" className="icon-formulario" />
                </MyButton>
              ) : (
                <MyButton tip="Realizar Mantenimiento" onClick={this.handlePostMto}>
                  <FaPlus color="#03178C" className="icon-formulario" />
                </MyButton>
              )
            )}
          </DialogActions>
        </Dialog>


            <Dialog
             open={this.state.opendelete}
             onClose={this.handleCloseDelete}
             fullWidth
            maxWidth="sm"
            >

            {this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-delete'>
                    <FaTrash color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Reporte Borrado Exitosamente</h2>
              </div>
                
                ):(<div>
                <DialogTitle>¿Estás seguro de borrar programación de Mto?</DialogTitle>
                </div>)}
            

            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseDelete}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>
             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                  <MyButton tip="Continuar" onClick={this.handleCloseDelete}>
                    <FaCheckCircle color="#f9044e" className="icon-formulario" />
                  </MyButton>
                ) : (
                  <MyButton tip="Borrar Programación" onClick={this.handleDelete}>
                    <FaTrash color="#03178C" className="icon-formulario" />
                  </MyButton>
                )
              )}
            
           </DialogActions>
            </Dialog>

            
            <Dialog
             open={this.state.openEdit}
             onClose={this.handleCloseEdit}
             fullWidth
            maxWidth="sm"
            >

            {this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-aprobado'>
                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Programación Editada Exitosamente</h2>
              </div>
                
                ):(<div>
                <DialogTitle><Typography sx={{ 
                                  fontSize: '20px', 
                                  fontWeight: 600, 
                                  color: '#0468BF', 
                                  textAlign: 'center' 
                                  }}>
                                  Editar Programación de Mantenimiento
                  </Typography></DialogTitle>

                <DialogContent>

                  <Grid container spacing={2}>
                    <Grid item xs={12} spacing={2}>
                        <TextField className="login-input-email"
                        sx={{ mt: 2 }}
                                                 required
                                                 type="date"
                                                 name="fecha"
                                                 id="fecha"
                                                 label="Fecha Programada"
                                                 value={this.state.fecha}
                                                 onChange={this.handleChange}
                                                 min="2019-01-01" max="2022-01-01"
                                                 fullWidth
                                                 helperText={errors.fecha}
                                                 error={errors.fecha?true:false}
                                                 InputLabelProps={{
                                                   shrink: true,
                                                 }}
                                                 />
                    </Grid>

                 <Grid item xs={12}>
                        <TextField
                          required
                          type="time"
                          name="hora"
                          id="hora"
                          label="Hora de Mantenimiento"
                          value={this.state.hora ? this.state.hora.padStart(5, "0") : ""}
                          onChange={this.handleChange}
                          min="06:00"
                          max="22:00"
                          fullWidth
                          helperText={errors.hora}
                          error={Boolean(errors.hora)}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>

                    <Grid item xs={12}>
                  <FormControl 
                        fullWidth 
                        required 
                        error={Boolean(errors.duracion)} 
                        sx={{ mt: 2 }} // margin-top de 16px, puedes ajustar si deseas
                      >
                        <InputLabel id="duracion-label">Duración en Horas</InputLabel>
                        <Select
                          labelId="duracion-label"
                          id="duracion"
                          name="duracion"
                          value={this.state.duracion}
                          onChange={this.handleChange}
                          label="Duración en Horas"
                        >
                          <MenuItem value="">
                            <em>Selecciona una opción</em>
                          </MenuItem>
                          {[0.5, 1, 2, 3, 4, 5, 6, 7, 8].map((hora) => (
                            <MenuItem key={hora} value={hora}>{hora}</MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>{errors.duracion}</FormHelperText>
                      </FormControl>
                    </Grid>
                                         <Grid item xs={12}>
                                           <TextField
                                             fullWidth
                                             multiline
                                             rows={4}
                                             variant="outlined"
                                             size="small"
                                             label="Actividades"
                                             name="actividades"
                                             value={this.state.actividades}
                                             onChange={this.handleChange}
                                             error={Boolean(errors.actividades)}
                                             helperText={errors.actividades}
                                           />
                                         </Grid>
                                       </Grid>

              

                </DialogContent>

                </div>)}
            

            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseEdit}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>
             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                  <MyButton tip="Continuar" onClick={this.handleCloseEdit}>
                    <FaCheckCircle color="#0cae1aff" className="icon-formulario" />
                  </MyButton>
                ) : (
                  <MyButton tip="Editar Programación" onClick={this.handleEdit}>
                    <FaPencilAlt color="#03178C" className="icon-formulario" />
                  </MyButton>
                )
              )}
            
           </DialogActions>
            </Dialog>
        

            </div>
        )
    }
}
TablaCronogramaMto.propTypes = {
  getListaMtos: PropTypes.func.isRequired,
  getListaMtosClienteFiltrado: PropTypes.func.isRequired,
  postMtoTablaV2:PropTypes.func.isRequired,
  editProgMtoV2:PropTypes.func.isRequired,
  getUsuariosAsistenciales:PropTypes.func.isRequired,
  data: PropTypes.shape({
    equiposmto: PropTypes.array,
    loadingmto: PropTypes.bool
  }).isRequired,
  clienteId: PropTypes.string.isRequired,
  UI: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  deleteProgMtoTabla: PropTypes.func.isRequired,
  editProgMto: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  data: state.data,
  user: state.user,
  UI: state.UI
});

export default connect(
  mapStateToProps,
  {
    getListaMtosClienteFiltrado,
    getListaMtos,
    deleteProgMtoTabla,
    editProgMto,
    postMtoTablaV2,
    getUsuariosAsistenciales,
    editProgMtoV2
  }
)(TablaCronogramaMto);